import React, { useState, useContext } from "react";
import { GlobalContext } from "../../context/provider";
import createaction from "../../context/action/company/createaction";
import Companylist from "./companylist";
const Company = () => {
  const { initState, recaller, setrecaller, initDispatch, clear } =
    useContext(GlobalContext);

  const [name, setname] = useState();
  const [address, setaddress] = useState();
  const [phone, setphone] = useState();
  const [loan, setloan] = useState();
  const [company_date, setcompany_date] = useState();


  const [error, seterror] = useState(false);
  const [error1, seterror1] = useState(false);
  const [error2, seterror2] = useState(false);
  const [error3, seterror3] = useState(false);

  return (
    <div className="min-h-screen bg-slate-50 p-6 md:p-8">
      {/* Page Header */}
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-2xl font-bold text-slate-800">کۆمپانیای دابینکار</h1>
          <p className="text-sm text-slate-400 mt-0.5">بەڕێوەبردنی کۆمپانیاکان</p>
        </div>
      </div>

      {/* Add New Company Form */}
      <div className="bg-white border border-slate-100 rounded-xl p-6 mb-6 shadow-sm">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 items-end">
        <div className="w-full">
          <label
            className={
              error
                ? "block text-sm font-medium text-red-500 mb-1 text-right"
                : "block text-sm font-medium text-slate-500 mb-1 text-right"
            }
            htmlFor="company_name"
          >
            ناوی کۆمپانیا
          </label>
          <input
            className={
              error
                ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
            }
            id="company_name"
            type="text"
            placeholder=""
            onClick={(val) => {val.target.select()}}
            value={name}
            onChange={(val) => setname(val.target.value)}
            onFocus={() => seterror(false)}
          />
        </div>
        <div className="w-full">
          <label
            className={
              error1
                ? "block text-sm font-medium text-red-500 mb-1 text-right"
                : "block text-sm font-medium text-slate-500 mb-1 text-right"
            }
            htmlFor="company_address"
          >
            ناونیشان
          </label>
          <input
            className={
              error1
                ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
            }
            id="company_address"
            type="text"
            placeholder=""
            onClick={(val) => {val.target.select()}}
            value={address}
            onChange={(val) => setaddress(val.target.value)}
            onFocus={() => seterror1(false)}
          />
        </div>
        <div className="w-full">
          <label
            className={
              error2
                ? "block text-sm font-medium text-red-500 mb-1 text-right"
                : "block text-sm font-medium text-slate-500 mb-1 text-right"
            }
            htmlFor="company_phone"
          >
            ژمارەی تەلەفۆن
          </label>
          <input
            className={
              error2
                ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
            }
            id="company_phone"
            type="text"
            placeholder=""
            onClick={(val) => {val.target.select()}}
            value={phone}
            onChange={(val) => setphone(val.target.value)}
            onFocus={() => seterror2(false)}
          />
        </div>
        <div className="w-full">
          <label
            className={
              error3
                ? "block text-sm font-medium text-red-500 mb-1 text-right"
                : "block text-sm font-medium text-slate-500 mb-1 text-right"
            }
            htmlFor="company_loan"
          >
            قەرزی بنچینەی
          </label>
          <input
            className={
              error3
                ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-red-500"
                : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-indigo-500"
            }
            id="company_loan"
            type="number"
            placeholder=""
            onClick={(val) => {val.target.select()}}
            value={loan}
            onChange={(val) => setloan(val.target.value)}
            onFocus={() => seterror3(false)}
          />
        </div>
        {/* <div className="w-full">
          <label
            className={
              "block text-sm font-medium text-slate-500 mb-1 text-right"
            }
            htmlFor="company_date"
          >
            بەروار
          </label>
          <input
            className={
              "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-indigo-500"
            }
            id="company_date"
            type="date"
            placeholder=""
            onClick={(val) => {val.target.select()}}
            value={company_date}
            onChange={(val) => setcompany_date(val.target.value)}
          />
        </div> */}
        <div className="w-full">
          <button
            className="h-10 px-6 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold rounded-lg transition-colors duration-150 w-full"
            onClick={() => {
              if (name == "" || !name) {
                seterror(true);
                return false;
              }
              if (address == "" || !address) {
                seterror1(true);
                return false;
              }
              if (phone == "" || !phone) {
                seterror2(true);
                return false;
              }
              if (loan < 0 || !name) {
                seterror3(true);
                return false;
              }
              createaction(name, address, phone, loan, initState.token.user_id)(recaller)(setrecaller)(initDispatch)(clear);
              // createaction(name, address, phone, loan, company_date, initState.token.user_id)(recaller)(setrecaller)(initDispatch)(clear);
            }}
          >
            زیادکردن
          </button>
        </div>
      </div>
      </div>

      {/* Company List Section */}
      <Companylist />
    </div>
  );
};

export default Company;
